// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityPropertySchemaBuf } from '../entity/entity-property-schema-buf.js';
import { EntityPropertyStatusBuf } from '../entity/entity-property-status-buf.js';
import { EntityPropertyTimestampBuf } from '../entity/entity-property-timestamp-buf.js';
import { SearchIdBuf } from '../search/search-id-buf.js';
import { SearchPropertyIdBuf } from '../search/search-property-id-buf.js';


export class SearchPropertyBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SearchPropertyBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSearchPropertyBuf(bb:flatbuffers.ByteBuffer, obj?:SearchPropertyBuf):SearchPropertyBuf {
  return (obj || new SearchPropertyBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSearchPropertyBuf(bb:flatbuffers.ByteBuffer, obj?:SearchPropertyBuf):SearchPropertyBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SearchPropertyBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

searchId(obj?:SearchIdBuf):SearchIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new SearchIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

propertyId(obj?:SearchPropertyIdBuf):SearchPropertyIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new SearchPropertyIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

version():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

schema():EntityPropertySchemaBuf {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : EntityPropertySchemaBuf.FileIdValue;
}

timestamp(obj?:EntityPropertyTimestampBuf):EntityPropertyTimestampBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new EntityPropertyTimestampBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

value(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
}

valueLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

valueArray():Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? new Uint8Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

deleted():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

status():EntityPropertyStatusBuf {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : EntityPropertyStatusBuf.StatusCurrent;
}

epochId():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : null;
}

static startSearchPropertyBuf(builder:flatbuffers.Builder) {
  builder.startObject(9);
}

static addSearchId(builder:flatbuffers.Builder, searchIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, searchIdOffset, 0);
}

static addPropertyId(builder:flatbuffers.Builder, propertyIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, propertyIdOffset, 0);
}

static addVersion(builder:flatbuffers.Builder, version:number) {
  builder.addFieldInt32(2, version, 0);
}

static addSchema(builder:flatbuffers.Builder, schema:EntityPropertySchemaBuf) {
  builder.addFieldInt32(3, schema, EntityPropertySchemaBuf.FileIdValue);
}

static addTimestamp(builder:flatbuffers.Builder, timestampOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, timestampOffset, 0);
}

static addValue(builder:flatbuffers.Builder, valueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, valueOffset, 0);
}

static createValueVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset {
  builder.startVector(1, data.length, 1);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt8(data[i]!);
  }
  return builder.endVector();
}

static startValueVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(1, numElems, 1);
}

static addDeleted(builder:flatbuffers.Builder, deleted:boolean) {
  builder.addFieldInt8(6, +deleted, +false);
}

static addStatus(builder:flatbuffers.Builder, status:EntityPropertyStatusBuf) {
  builder.addFieldInt8(7, status, EntityPropertyStatusBuf.StatusCurrent);
}

static addEpochId(builder:flatbuffers.Builder, epochId:number) {
  builder.addFieldInt32(8, epochId, null);
}

static endSearchPropertyBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 4) // search_id
  builder.requiredField(offset, 6) // property_id
  builder.requiredField(offset, 12) // timestamp
  builder.requiredField(offset, 14) // value
  return offset;
}

}
